(function() {
  function activate(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll('.js-lazy-src-image');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      var sizes = img.getAttribute('data-sizes');
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (sizes) {
        img.setAttribute('sizes', sizes);
        img.removeAttribute('data-sizes');
      }
      img.classList.remove('js-lazy-src-image');
    }
  }

  // Expose for scripts that inject cards after initial load (e.g. collection load-more).
  window.activateDeferredImages = activate;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { activate(); });
  } else {
    activate();
  }
})();
